import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { applicationTypes } from './config';
import { buildTypeListPath, buildDetailsPath } from './paths';

/**
 * Your Backstage version (frontend-plugin-api ^0.18.0) removed
 * NavItemBlueprint in 1.51 — navigation used to be discovered from a
 * page's `title`/`icon` params instead, but we deliberately skip that too
 * (see ApplicationSidebarItems.tsx for why) and just register plain
 * routes here. That's the only job of this file: no nav concerns at all.
 *
 * One list PageBlueprint + one details PageBlueprint per configured
 * application type, generated from config.ts in a loop — adding a new
 * type still requires zero new page/route code.
 */
const pages = applicationTypes.flatMap(app => [
  PageBlueprint.make({
    name: app.key,
    params: {
      path: buildTypeListPath(app.key),
      loader: () =>
        import('./ApplicationTypePage').then(m => (
          <m.ApplicationTypePage type={app.key} />
        )),
    },
  }),
  PageBlueprint.make({
    name: `${app.key}-details`,
    params: {
      path: buildDetailsPath(app.key, ':name'),
      loader: () =>
        import('./ApplicationDetailsPage').then(m => (
          <m.ApplicationDetailsPage type={app.key} />
        )),
    },
  }),
]);

export const applicationConsolePlugin = createFrontendPlugin({
  pluginId: 'application-console',
  extensions: pages,
});
